import styled, { css } from 'styled-components'

interface PropsType {
  gridTemplateColumns: string
  gridTemplateRows?: string
  rowGap?: string
  columnGap?: string
  gap?: string
  width?: string
  maxWidth?: string
  alignItems?: 'center' | 'flex-end' | 'flex-start' | 'baseline'
  justifyContent?: 'center' | 'flex-end' | 'flex-start'
  padding?: string
  gridColumnGap?: string
  gridRowGap?: string
  overflow?: 'hidden' | 'scroll'
  height?: string
  bgColor?: string
  margin?: string
}

const CssGrid = styled.div<PropsType>`
  display: grid;
  width: ${({ width }) => width ?? '100%'};
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
  grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows ?? 'auto'};
  row-gap: ${({ rowGap }) => rowGap ?? '0'};
  column-gap: ${({ columnGap }) => columnGap ?? '0'};
  align-items: ${({ alignItems }) => alignItems};
  height: ${({ height }) => height ?? 'auto'};

  gap: ${({ gap }) => gap};

  ${({ padding }) =>
    padding &&
    css`
      padding: ${padding};
    `}
  ${({ gridColumnGap }) =>
    gridColumnGap &&
    css`
      grid-column-gap: ${gridColumnGap};
    `}
  ${({ gridRowGap }) =>
    gridRowGap &&
    css`
      grid-row-gap: ${gridRowGap};
    `}
  ${({ overflow }) =>
    overflow &&
    css`
      overflow: ${overflow};
    `}
    ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
    ${({ bgColor }) =>
    bgColor &&
    css`
      background: ${bgColor};
    `}
    ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
    ${({ justifyContent }) =>
    justifyContent &&
    css`
      justify-content: ${justifyContent};
    `}
`

export default CssGrid
